import AdditionalCostEstimate from "./AdditionalCostEstimate";
import Circle from "./Circle";
import RequestDetailsCard from "./RequestDetailsCard";
import { Title } from "./Title";
import { TopInfoCard } from "./TopInfoCard";

const JobCost = ({request, isAlert}) => {
    return(
        <>
            {isAlert && <TopInfoCard/>}
            {isAlert && <Title/>}

            <RequestDetailsCard
                key={request.ftm_request_id}
                request={request}
                isAlert={isAlert}
            />

            <AdditionalCostEstimate request_materials={request.request_materials} />

            {isAlert && (
                <div className="px-2 mt-2 text-dark">
                    {[
                        "This is an estimate of additional costs only.",
                        "Labour continues to be charged based on time on site.",
                        "You will approve the final total before payment.",
                        "Approving allows the tradesperson to continue the job.",
                        "If not approved, work may pause and the job may need to be closed.",
                    ].map((text, index) => (
                        <div
                            key={index}
                            className={`d-flex align-items-start ${index === 3 ? "mt-4" : "mb-2"}`}
                        >
                            <Circle/>
                            <p className="mb-0 text-xs-89">{text}</p>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default JobCost;